export enum TaskType {
    Base,
    Transition
}